import { render, staticRenderFns } from "./inboxThread.vue?vue&type=template&id=4fb2bf61&scoped=true&"
import script from "./inboxThread.vue?vue&type=script&lang=js&"
export * from "./inboxThread.vue?vue&type=script&lang=js&"
import style0 from "./inboxThread.vue?vue&type=style&index=0&id=4fb2bf61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb2bf61",
  null
  
)

export default component.exports